import { notificationExtraFields } from "@/src/features/notifications/storedShape";
import { completionJobIdSchema } from "./legacyWorkflowIdentity";
import { buildNotificationHandoff } from "./continuity/continuity";
import type { NotificationHandoffInput } from "./continuity/contracts";
import { isWorkspaceSceneId } from "./jobCompletionDestination";

/**
 * Only the owned feed's matching typed job handoff can nominate a follow-up.
 * Reads the hand-off from either row shape: a stored feed row carries it
 * lifted onto the row, a display row nests it under `extraFields`.
 */
export function completionNotification(value: any) {
  if (value?.notificationType !== "task_update" || value.sourceObjectType !== "job") return null;
  try {
    const extras = notificationExtraFields(value);
    // The builder validates every field and throws on a malformed hand-off.
    const handoff = buildNotificationHandoff(extras?.continuityHandoff as NotificationHandoffInput);
    const id = value.id ?? value._key;
    const sceneId = extras?.workspaceSceneId;
    if (handoff.target.kind !== "job" || !completionJobIdSchema.safeParse(handoff.target.id).success || handoff.target.id !== value.sourceObjectId || handoff.notificationId !== id
      || handoff.dedupeKey !== value.dedupeKey || sceneId !== null && !isWorkspaceSceneId(sceneId)) return null;
    return { handoff, sceneId: sceneId as string | null };
  } catch { return null; }
}
